<template>
  <v-layout>
    <b-row v-if="pharmacy">
      <b-col xs="12" sm="12">
        <PharmacyDetail :pharmacy="pharmacy" />
      </b-col>
    </b-row>
    <div>
      <vue-element-loading :active="$checkingAuthState" />
    </div>
    <ProductList
      v-if="!$checkingAuthState"
      :categories="pharmacyCategories"
      :selectedCategory="selectedCategory"
      :brandUuid="brandUuid"
      :pharmacyUuid="pharmacyUuid"
    >
    </ProductList>
  </v-layout>
</template>


<script>
import { mapGetters } from "vuex";

import VLayout from "@/layouts/Default";
import PharmacyDetail from "@/components/PharmacyDetail";
import ProductList from "@/components/ProductList";

export default {
  components: {
    VLayout,
    ProductList,
    PharmacyDetail,
  },
  props: {
    categoryUuid: {
      default: "",
      type: String,
    },
    brandUuid: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      pharmacy: undefined,
      pharmacyUuid: this.$route.params.pharmacyUuid,
    };
  },
  computed: {
    ...mapGetters("drugs", ["pharmacyCategories", "getCategoryByUuid"]),
    selectedCategory() {
      if (this.categoryUuid) {
        return this.getCategoryByUuid(this.categoryUuid);
      }
      return undefined;
    },
  },
  watch: {
    $route () {
      this.loadBreadcrumb();
    },
  },
  created() {
    this.loadPharmacy();
  },
  methods: {
    loadBreadcrumb () {
      var breadcrumb = this.makeCategoriesBreadcrumb(this.selectedCategory);
      if (this.pharmacy) {
        breadcrumb.push({
          langkey: this.pharmacy.public_name,
          route: this.$route.name,
        });
      }
      breadcrumb.push({ langkey: "pharmacy_detail.pharmacies", route: "listpharmacies" });
      breadcrumb.push({ langkey: "home.breadcrumb", route: "home" });
      breadcrumb.reverse();
      try {
        this.$store.dispatch("siteconf/CHANGE_BREADCRUMB", breadcrumb);
      } catch (err) {
        this.$sentry({ capture: err });
      }
    },
    makeCategoriesBreadcrumb(category, breadcrumb = []) {
      if (category) {
        breadcrumb.push({ langkey: category.name, route: this.$route.name });
        if (category.parent != null) {
          return this.makeCategoriesBreadcrumb(category.parent, breadcrumb);
        }
      }
      return breadcrumb;
    },
    loadPharmacy() {
      if (this.pharmacyUuid) {
        this.$store
          .dispatch("organization/GET_PHARMACY", {
            uuid: this.pharmacyUuid,
          })
          .then(
            response => {
              if (response.data) {
                this.pharmacy = response.data;
                this.loadBreadcrumb();
              } else {
                this.pharmacy = undefined;
              }
            },
            err => {
              this.$sentry({ capture: err });
              this.$router.push({ name: "fallback-error-page" });
            }
          );
      }
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        pharmacy_detail: {
          pharmacies: "Pharmacies",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .breadcrumb-item.active p {
  text-transform: capitalize !important;
}
</style>
